import { Flex, Text } from '@spotify-internal/encore-web';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { useArtifactDisplay } from '../../hooks/useArtifactDisplay';
import { ArtifactActionsMenu } from '../ArtifactActionsMenu';
import { ArtifactIcon } from '../ArtifactIcon';

import styles from './ArtifactCardBase.module.css';

const stopPropagation = (e: { stopPropagation: () => void }) =>
  e.stopPropagation();

interface ArtifactCardBaseProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  onNavigate: () => void;
  onDelete?: () => void;
}

export const ArtifactCardBase = ({
  artifact,
  resolvedDisplayName,
  onNavigate,
  onDelete,
}: ArtifactCardBaseProps) => {
  const { Icon, typeLabel, displayName } = useArtifactDisplay(
    artifact,
    resolvedDisplayName,
  );

  return (
    <button type="button" className={styles.cardButton} onClick={onNavigate} data-track-source-anchor="ef2187f322;artifact-card-base-button">
      <Flex direction="column" className={styles.card}>
        <div className={styles.cardBody}>
          <Flex alignItems="center" gap="tighter-2">
            <ArtifactIcon>
              <Icon size={16} />
            </ArtifactIcon>
            <Flex direction="column" className={styles.info}>
              <Text
                variant="bodyMediumBold"
                semanticColor="textBase"
                textWrap="nowrap"
                className={styles.displayNameText}
              >
                {displayName}
              </Text>
              <Text
                variant="bodySmall"
                semanticColor="textSubdued"
                textWrap="nowrap"
              >
                {typeLabel}
              </Text>
            </Flex>
            <span
              role="toolbar"
              className={styles.menuButton}
              onClick={stopPropagation}
              onKeyDown={stopPropagation}
             data-track-source-anchor="a6f173ecc2">
              <ArtifactActionsMenu
                artifact={artifact}
                displayName={displayName}
                resolvedDisplayName={resolvedDisplayName}
                onDelete={onDelete}
              />
            </span>
          </Flex>
        </div>
      </Flex>
    </button>
  );
};
